import React from "react";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Table from "material-ui/Table";
import { TableBody, TableHead } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableRow } from "material-ui/Table";
import { withStyles } from "material-ui/styles";
import { RadioGroup, Radio, FormControlLabel } from "material-ui";
import styles from "./styles";

class MacTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isBoth: props.subtestStatsResults.mac.length == 2 ? true : false,
      data:
        props.subtestStatsResults.mac.length == 2
          ? props.subtestStatsResults.mac.find(item => {
              return item.rh === false;
            })
          : props.subtestStatsResults.mac[0],
      macType: "main"
    };
  }

  formatNumber = number => {
    if (
      (number.toString().split(".")[0] &&
        number.toString().split(".")[0].length > 9) ||
      (number.toString().split(".")[1] &&
        number.toString().split(".")[1].length > 6)
    ) {
      return number.toExponential(3).toUpperCase();
    } else return number;
  };
  formatNumberbps = number => {
    if (number >= 0 && number <= 999) return number + " (b/s)";
    else if (number >= 1000 && number <= 999999)
      return number / 1000 + " (Kb/s)";
    else if (number >= 1000000 && number <= 999999999)
      return (number / 1000000).toFixed(3) + " (Mb/s)";
    else return (number / 1000000000).toFixed(3) + " (Gb/s)";
  };
  onChange = e => {
    if (e.target.value === "main") {
      let tempData = this.props.subtestStatsResults.mac.find(item => {
        return item.rh === false;
      });
      this.setState({ data: tempData, macType: e.target.value });
    } else {
      let tempData = this.props.subtestStatsResults.mac.find(item => {
        return item.rh === true; //change it to true
      });
      this.setState({ data: tempData, macType: e.target.value });
    }
  };

  render() {
    const { subtestStatsResults, classes } = this.props;
    let { isBoth, data, macType } = this.state;

    return (
      <div>
        <Grid container spacing={40}>
          <Grid item xs={12} className={this.props.classes.mac_heading}>
            {isBoth == true ? (
              <RadioGroup
                aria-label=""
                name="macType"
                value={macType}
                onChange={this.onChange}
                className={classes.radioGroup}
              >
                <FormControlLabel
                  value={"main"}
                  control={<Radio />}
                  label={this.props.translate("results_chart_display")}
                />
                <FormControlLabel
                  value={"remote"}
                  control={<Radio />}
                  label={this.props.translate("results_chart_remote")}
                />
              </RadioGroup>
            ) : (
              <Typography
                className={this.props.classes.heading}
                color="inherit"
              >
                {data.rh == false
                  ? this.props.translate("results_chart_display")
                  : this.props.translate("results_chart_remote")}
              </Typography>
            )}
          </Grid>
          <Grid item xs={4}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableheader_first} />

                  <TableCell className={classes.tableheader_first} />
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {this.props.translate("result_unicast")}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {data && data.unicast && data.unicast != null
                      ? this.formatNumber(data.unicast)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {this.props.translate("result_broadcast")}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {data && data.broadcast && data.broadcast != null
                      ? this.formatNumber(data.broadcast)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {this.props.translate("result_multicasts")}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {data && data.multicast && data.multicast != null
                      ? this.formatNumber(data.multicast)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {this.props.translate("result_tot_rx_fr")}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {data && data.totalframes && data.totalframes != null
                      ? this.formatNumber(data.totalframes)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {this.props.translate("result_tot_rx_byt")}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {data && data.totalbytes && data.totalbytes != null
                      ? this.formatNumber(data.totalbytes)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {this.props.translate("frame_errors") + ":"}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {data && data.totalerrors && data.totalerrors != null
                      ? this.formatNumber(data.totalerrors)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {this.props.translate("result_max_fr_per_sec")}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {data &&
                    data.maxframespersecond &&
                    data.maxframespersecond != null
                      ? this.formatNumber(data.maxframespersecond)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {this.props.translate("result_cur_data_rate")}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {data &&
                    data.currentdatarate &&
                    data.currentdatarate != null
                      ? this.formatNumberbps(data.currentdatarate)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {this.props.translate("result_avg_data_rate")}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {data &&
                    data.averagedatarate &&
                    data.averagedatarate != null
                      ? this.formatNumberbps(data.averagedatarate)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {this.props.translate("result_max_data_rate")}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {data && data.maxdatarate && data.maxdatarate != null
                      ? this.formatNumberbps(data.maxdatarate)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {this.props.translate("result_cur_util")}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {data &&
                      data.currentutilization &&
                      data.currentutilization.toFixed(3)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {this.props.translate("result_avg_util")}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {data &&
                      data.averageutilization &&
                      data.averageutilization.toFixed(3)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {this.props.translate("result_max2_util")}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {data &&
                      data.maxutilization &&
                      data.maxutilization.toFixed(3)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
          <Grid item xs={4}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.mac_tableheader_first}>
                    {this.props.translate("result_fr_len")}
                  </TableCell>

                  <TableCell className={classes.mac_tableheader}>
                    {this.props.translate("subset_ping_count")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.mac_tablecontent}>
                    {this.props.translate("result_l64")}
                  </TableCell>
                  <TableCell className={classes.mac_tablecontent_right}>
                    {data && data.lessthan64 && data.lessthan64 != null
                      ? this.formatNumber(data.lessthan64)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.mac_tablecontent}>
                    {this.props.translate("result_l127")}
                  </TableCell>
                  <TableCell className={classes.mac_tablecontent_right}>
                    {data && data.lessthan128 && data.lessthan128 != null
                      ? this.formatNumber(data.lessthan128)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.mac_tablecontent}>
                    {this.props.translate("result_l255")}
                  </TableCell>
                  <TableCell className={classes.mac_tablecontent_right}>
                    {data && data.lessthan256 && data.lessthan256 != null
                      ? this.formatNumber(data.lessthan256)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.mac_tablecontent}>
                    {this.props.translate("result_l511")}
                  </TableCell>
                  <TableCell className={classes.mac_tablecontent_right}>
                    {data && data.lessthan512 && data.lessthan512 != null
                      ? this.formatNumber(data.lessthan512)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.mac_tablecontent}>
                    {this.props.translate("result_l1023")}
                  </TableCell>
                  <TableCell className={classes.mac_tablecontent_right}>
                    {data && data.lessthan1024 && data.lessthan1024 != null
                      ? this.formatNumber(data.lessthan1024)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.mac_tablecontent}>
                    {this.props.translate("result_l1279")}
                  </TableCell>
                  <TableCell className={classes.mac_tablecontent_right}>
                    {data && data.lessthan1280 && data.lessthan1280 != null
                      ? this.formatNumber(data.lessthan1280)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.mac_tablecontent}>
                    {this.props.translate("result_l1518")}
                  </TableCell>
                  <TableCell className={classes.mac_tablecontent_right}>
                    {data && data.lessthan1519 && data.lessthan1519 != null
                      ? this.formatNumber(data.lessthan1519)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.mac_tablecontent}>
                    {this.props.translate("result_l1522")}
                  </TableCell>
                  <TableCell className={classes.mac_tablecontent_right}>
                    {data && data.lessthan1523 && data.lessthan1523 != null
                      ? this.formatNumber(data.lessthan1523)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.mac_tablecontent}>
                    {this.props.translate("result_m1522")}
                  </TableCell>
                  <TableCell className={classes.mac_tablecontent_right}>
                    {data &&
                    data.greaterthan1523 &&
                    data.greaterthan1523 != null
                      ? this.formatNumber(data.greaterthan1523)
                      : ""}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
          <Grid item xs={4}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableheader_first}>
                    {this.props.translate("result_frame_error")}
                  </TableCell>

                  <TableCell className={classes.tableheader_first}>
                    {this.props.translate("subset_ping_count")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {this.props.translate("result_fcs")}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {data && data.badfcscount && data.badfcscount != null
                      ? this.formatNumber(data.badfcscount)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {this.props.translate("result_un_fr")}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {data &&
                    data.undersizedframescount &&
                    data.undersizedframescount != null
                      ? this.formatNumber(data.undersizedframescount)
                      : ""}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tablecontent_first}>
                    {this.props.translate("result_ov_fr")}
                  </TableCell>
                  <TableCell className={classes.tablecontent_first}>
                    {data &&
                    data.oversizedframescount &&
                    data.oversizedframescount != null
                      ? this.formatNumber(data.oversizedframescount)
                      : ""}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      </div>
    );
  }
  componentWillMount() {
    const { subtestStatsResults } = this.props;
    this.setState({ data: subtestStatsResults.mac[0] });
  }
  // componentWillReceiveProps(nextProps) {
  //   const { getStatsResult, subtest, pager } = nextProps;
  //   if (this.props.pager.tid !== pager.tid || subtest !== this.props.subtest) {
  //     getStatsResult(pager.jid, pager.tid, subtest, null);
  //   }
  // }
}

export default withStyles(styles)(MacTab);



// WEBPACK FOOTER //
// ./src/components/common/results/views/stats/macTab.js